export default [
  {
    path: '/iframe',
    component: () => import('@/views/home/IFrame.vue'),
    name: 'iframe',
    meta: {
      title: '',
      backgroundClass: 'bg-black',
    },
    hidden: true,
  },
  {
    path: '/download',
    component: () => import('@/views/home/Download.vue'),
    name: 'download',
    meta: {
      title: 'YAMAHA APP下载',
      backgroundClass: 'bg-download',
    },
    hidden: true,
  },
  {
    path: '/download.html',
    component: () => import('@/views/home/Download.vue'),
    name: 'downloadHtml',
    meta: {
      title: 'YAMAHA APP下载',
      backgroundClass: 'bg-download',
    },
    hidden: true,
  },
  {
    path: '/testDrive',
    component: () => import('@/views/home/TestDrive.vue'),
    name: 'testDrive',
    meta: {
      title: '预约试驾',
      backgroundClass: 'bg-black',
    },
    hidden: true,
  },
  {
    path: '/album-detail-:id',
    component: () => import('@/views/home/AlbumDetail.vue'),
    name: 'album.detail',
    meta: {
      title: '商品详情',
      backgroundClass: 'bg-black',
    },
    hidden: true,
  },
  {
    path: '/banner/offline.html',
    component: () => import('@/views/home/banner/Offline.vue'),
    name: 'banner.offline',
    meta: {
      title: '活动已结束，感谢您的关注',
      backgroundClass: 'bg-black',
    },
    hidden: true,
  },
  {
    path: '/klicen/klicenRights.html',
    component: () => import('@/views/home/klicen/KlicenRights.vue'),
    name: 'klicen.klicenRights',
    meta: {
      title: '凯励程保障服务',
      backgroundClass: 'bg-black',
    },
    hidden: true,
  },
];
